import type { VaultConfigResponse } from "./vault-config";

export const vaultConfigMock: VaultConfigResponse = {
  chains: {
    "1": {
      id: 1,
      name: "Ethereum",
      nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://eth.merkle.io"],
        },
      },
      blockExplorers: {
        default: {
          name: "Etherscan",
          url: "https://etherscan.io",
          apiUrl: "https://api.etherscan.io/api",
        },
      },
      contracts: {
        ensRegistry: {
          address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        },
        ensUniversalResolver: {
          address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
          blockCreated: 19258213,
        },
        multicall3: {
          address: "0xca11bde05977b3631167028862be2a173976ca11",
          blockCreated: 14353601,
        },
      },
    },
    "288": {
      id: 288,
      name: "Boba Network",
      nativeCurrency: {
        decimals: 18,
        name: "Ether",
        symbol: "ETH",
      },
      rpcUrls: {
        default: {
          http: ["https://mainnet.boba.network"],
        },
      },
      blockExplorers: {
        default: {
          name: "BOBAScan",
          url: "https://bobascan.com",
        },
      },
      contracts: {
        multicall3: {
          address: "0xca11bde05977b3631167028862be2a173976ca11",
          blockCreated: 446859,
        },
      },
    },
    "478": {
      id: 478,
      name: "Form Network",
      nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://rpc.form.network/http"],
          webSocket: ["wss://rpc.form.network/ws"],
        },
      },
      blockExplorers: {
        default: {
          name: "Form Network Explorer",
          url: "https://explorer.form.network/",
        },
      },
      contracts: {
        multicall3: {
          address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        },
      },
    },
    "1329": {
      id: 1329,
      name: "Sei Network",
      nativeCurrency: {
        name: "Sei",
        symbol: "SEI",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://evm-rpc.sei-apis.com/"],
          webSocket: ["wss://evm-ws.sei-apis.com/"],
        },
      },
      blockExplorers: {
        default: {
          name: "Seitrace",
          url: "https://seitrace.com",
          apiUrl: "https://seitrace.com/pacific-1/api",
        },
      },
      contracts: {
        multicall3: {
          address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        },
      },
    },
    "1923": {
      id: 1923,
      name: "Swell Mainnet",
      nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://rpc.ankr.com/swell"],
          webSocket: ["wss://rpc.ankr.com/swell/ws"],
        },
      },
      blockExplorers: {
        default: {
          name: "Swell Chain Explorer",
          url: "https://explorer.swellnetwork.io/",
        },
      },
      contracts: {
        multicall3: {
          address: "0xcA11bde05977b3631167028862bE2a173976CA11",
          blockCreated: 32,
        },
      },
    },
    "98866": {
      id: 98866,
      name: "Plume Mainnet",
      nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://phoenix-rpc.plumenetwork.xyz"],
        },
      },
      blockExplorers: {
        default: {
          name: "Plume Mainnet Explorer",
          url: "https://phoenix-explorer.plumenetwork.xyz",
        },
      },
      contracts: {
        multicall3: {
          address: "0xF9DA0EF6635F6134D9d1B7eAE025159D26ce5838",
          blockCreated: 1,
        },
      },
    },
    "1380012617": {
      id: 1380012617,
      name: "Rari Chain",
      nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: {
        default: {
          http: ["https://mainnet.rpc.rarichain.org/http"],
          webSocket: ["wss://mainnet.rpc.rarichain.org/ws"],
        },
      },
      blockExplorers: {
        default: {
          name: "Rari Explorer",
          url: "https://mainnet.explorer.rarichain.org",
        },
      },
      contracts: {
        multicall3: {
          address: "0x3F5Fc48153f8aDd3E429F0c84fA6FEd5c58657Dc",
        },
      },
    },
  },
  vaults: {
    nTBILL: {
      contracts: {
        accountant: "0x0b738cd187872b265a689e8e4130c336e76892ec",
        boringVault: "0xe72fe64840f4ef80e3ec73a1c749491b5c938cb9",
        teller: "0x1492062b3ae7996c71f87a2b390b6b82afea0c59",
      },
      token: {
        name: "nTBILL",
        symbol: "NTBILL",
        decimals: 6,
        address: "0xe72fe64840f4ef80e3ec73a1c749491b5c938cb9",
      },
      deposit: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            depositTokens: {
              nRWA: {
                symbol: "nRWA",
                address: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
                decimals: 6,
              },
            },
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
              },
            },
          },
        },
      },
      withdraw: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
                wantTokens: {
                  nRWA: {
                    symbol: "nRWA",
                    address: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
                    decimals: 6,
                  },
                },
              },
            },
          },
        },
      },
    },
    nRWA: {
      contracts: {
        accountant: "0xe0CF451d6E373FF04e8eE3c50340F18AFa6421E1",
        boringVault: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
        teller: "0xc9F6a492Fb1D623690Dc065BBcEd6DfB4a324A35",
      },
      token: {
        name: "nRWA",
        symbol: "NRWA",
        decimals: 6,
        address: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
      },
      deposit: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            depositTokens: {
              pUSD: {
                symbol: "pUSD",
                address: "0xdddd73f5df1f0dc31373357beac77545dc5a6f3f",
                decimals: 6,
              },
            },
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
              },
            },
          },
          "1": {
            displayName: "Ethereum",
            depositTokens: {
              USDC: {
                symbol: "USDC",
                address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                decimals: 6,
              },
            },
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "layerzero",
                  chainIdentifier: 30370,
                },
              },
            },
          },
        },
      },
      withdraw: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
                wantTokens: {
                  pUSD: {
                    symbol: "pUSD",
                    address: "0xdddd73f5df1f0dc31373357beac77545dc5a6f3f",
                    decimals: 6,
                  },
                },
              },
            },
          },
        },
      },
    },
    "op-nRWA": {
      contracts: {
        accountant: "0x835dc91aedbb03175d7207ab022d15db6dff086d",
        boringVault: "0xab306afbf157534cdea99bf197f473362468692e",
        teller: "0x5592e17946f15205454e9c07ed4a86ecfb749678",
      },
      token: {
        name: "op-nRWA",
        symbol: "OP-NRWA",
        decimals: 6,
        address: "0xab306afbf157534cdea99bf197f473362468692e",
      },
      deposit: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            depositTokens: {
              nRWA: {
                symbol: "nRWA",
                address: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
                decimals: 6,
              },
              pUSD: {
                symbol: "pUSD",
                address: "0xdddD73F5Df1F0DC31373357beAC77545dC5A6f3F",
                decimals: 6,
              },
            },
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
              },
            },
          },
        },
      },
      withdraw: {
        sourceChains: {
          "98866": {
            displayName: "Plume Network",
            destinationChains: {
              "98866": {
                displayName: "Plume Network",
                bridge: {
                  type: "none",
                  chainIdentifier: 0,
                },
                wantTokens: {
                  nRWA: {
                    symbol: "nRWA",
                    address: "0x593cCcA4c4bf58b7526a4C164cEEf4003C6388db",
                    decimals: 6,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
